module.exports = __webpack_public_path__ + "img/business_2.4d020148.png";